import React from 'react';
import { Play } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative h-screen min-h-[600px] flex items-center pt-20" data-id="element-92">
      <div className="absolute inset-0 z-0" data-id="element-93">
        <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1600&q=80" alt="Modern building" className="w-full h-full object-cover" data-id="element-94" />
        <div className="absolute inset-0 bg-primary-dark/60 mix-blend-multiply" data-id="element-95"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-primary-dark/80 via-transparent to-primary-dark/90" data-id="element-96"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10 flex flex-col h-full justify-center" data-id="element-97">
        <div className="max-w-4xl" data-id="element-98">
          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="text-5xl md:text-7xl text-white font-serif leading-tight mb-4" data-id="element-99">
            Commercial AC installation & maintenance
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="text-xl md:text-2xl text-white/90 mb-10 font-light" data-id="element-100">
            Daikin D1+ Premier Partners | Nuneaton, West Midlands
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} data-id="element-101">
            <button className="group flex items-center gap-4 bg-accent hover:bg-accent/90 text-white px-6 py-3 rounded-full transition-all duration-300" data-id="element-102">
              <span className="font-medium" data-id="element-103">Get a free quote</span>
              <img src="https://cdn.magicpatterns.com/uploads/bPzFdwHywdHpFHfUSsV2QY/arrow-right-circle-white.svg" alt="" className="w-7 h-7 group-hover:translate-x-1 transition-transform" data-id="element-104" />
            </button>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="absolute bottom-12 left-6 right-6 flex flex-col md:flex-row justify-between items-start md:items-end gap-6" data-id="element-105">
          <div className="text-white/80 text-sm max-w-[200px] leading-relaxed flex flex-col items-start gap-4" data-id="element-106">
            <span data-id="element-107">
              Commercial HVAC specialists
              <br data-id="element-108" />
              for over 16 years.
            </span>
            <img src="https://cdn.magicpatterns.com/uploads/gipzk5sVfmcGVM4txQ5ruk/arrow-down-banner.svg" alt="Scroll down" className="w-5 h-5 animate-bounce" data-id="element-109" />
          </div>

          <div className="flex items-center gap-4 text-white/90 text-sm font-medium tracking-wide" data-id="element-110">
            <span data-id="element-111">Daikin Premier</span>
            <span className="w-1.5 h-1.5 rounded-full bg-accent" data-id="element-112"></span>
            <span data-id="element-113">16yr Lifespans</span>
            <span className="w-1.5 h-1.5 rounded-full bg-accent" data-id="element-114"></span>
            <span data-id="element-115">Constructionline Gold</span>
          </div>
        </motion.div>
      </div>
    </section>;
}